import { SharedState } from '@trello/shared-state';

export const a11yMenuState = new SharedState({
  colorVisionMode: '',
  isColorVisionEnabled: false,
  isTota11yInstalled: false,
  isTota11yEnabled: false,
});
